import React from "react"
import componentParser from "AtomicUtils/componentParser"
import { IS_IFRAME, WINDOW } from 'AtomicUtils/environment'
import debounce from 'AtomicUtils/debounce'
import cookieHandler from "AtomicUtils/cookieHandler"

class PersonalisationBlockContainer extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      windowWidth: WINDOW && WINDOW.innerWidth,
    }
  }

  componentDidMount(){
    this._updateDimensions()
    WINDOW.addEventListener("resize", debounce(this._updateDimensions,250));
  }

  componentWillUnmount() {
    WINDOW.removeEventListener("resize", debounce(this._updateDimensions,250));
  }

  _updateDimensions = () => {
    this.setState({
      windowWidth: WINDOW && WINDOW.innerWidth
    })
  }

  render() {
    let {
      items = []
    } = this.props

    const { windowWidth } = this.state

    if (items.length === 0) return (<div></div>)

    let filteredItems = [...items]
    // Filtering items based on iFrameOptions
    if (filteredItems.length > 1){
      filteredItems = filteredItems.filter(item => {
        if (item.props.iFrameOptions === 'showInIframe' && !IS_IFRAME) return false
        if (item.props.iFrameOptions === 'hideInIframe' && IS_IFRAME) return false
        return true
      })
    }

    // Filtering based on urlList
    let cookieHandlerObject = new cookieHandler();
    let history = cookieHandlerObject.getCookie("history");
    let newHistory = JSON.parse(history)

    filteredItems = filteredItems.filter(item => {
      if (item.urlList
        && item.urlList.length > 0
        && newHistory
        && newHistory.length > 0)
      {
        let found = false;
        newHistory.map((singleHistory)=>{
          if (item.urlList.includes(singleHistory)){
            found = true
          }
        })
        return found
      }
      return true
    })


    // Filtering based on mobile,desktop and tablet
    // Filtering based on window size 1200px 768px 529px
    if (windowWidth >= 768 && filteredItems.length > 1){
      filteredItems = filteredItems.filter(item => item.props.desktop)
    }else if (windowWidth >= 529 && windowWidth < 768 && filteredItems.length > 1){
      filteredItems = filteredItems.filter(item => item.props.tablet)
    }else if (windowWidth < 529 && filteredItems.length > 1){
      filteredItems = filteredItems.filter(item => item.props.mobile)
    }

    let itemToRender = []
    if (filteredItems.length > 0){
      itemToRender.push(filteredItems[0])
    }

    if (!itemToRender || !itemToRender[0] || itemToRender[0].name !== 'PersonalisationBlockItem')
      return <div></div>

    return (
      <div>
        {itemToRender.length > 0 && componentParser(itemToRender)}
      </div>
    )
  }
}


export default PersonalisationBlockContainer



// WEBPACK FOOTER //
// ./src/AtomicContainers/PersonalisationBlockContainer/PersonalisationBlockContainer.jsx